module.exports = __webpack_public_path__ + "img/violet-7.25982dab.png";